module.exports = __webpack_public_path__ + "static/media/Castle-Banner.14f3097d.png";